import './App.css';

import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Header from './components/Header';
import Memberships from './components/Memberships';
import Financing from "./components/Financing"
import Counseling from './components/Counseling';
// import Services from './components/Services';
import Section from './components/Section';
import FAQ from './components/FAQ';
import Awards from './components/Awards';
import Slice from './components/Slice';
import Experience from './components/Experience';


function App() {
  return (
    <main className="App">
      <Navbar />
      <Experience />
      <Header />
      <Slice />
      <Section />
      {/* <Services /> */}
      <Awards />
      <Memberships />
      <Financing />
      <FAQ />
      <Counseling />
      <Footer />
    </main>
  );
}

export default App;
